import * as type from '../types'

export const toggleSidebar = () => (
  {
    type: type.TOGGLE_SIDEBAR
  }
)
